import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@volca/ui/components/ui/badge";
import { Stack } from "@volca/ui/components/ui/stack";
import type { AccountTableUser } from "@/business-settings/users/web-app-users/users-table/types";

export const NameCol = (): ColumnDef<AccountTableUser> => ({
  header: "User name",
  accessorKey: "name",
  cell: ({ row }) => (
    <Stack direction="row" align="center" gap={2} wrap>
      <span className="min-w-0 break-words">{row.original.name}</span>
      {row.original.accessPerson?.removed && (
        <Badge variant="secondary" size="sm">
          Removed
        </Badge>
      )}
      {row.original.accessPerson?.business_member === false && (
        <Badge variant="secondary" size="sm">
          Parent company
        </Badge>
      )}
    </Stack>
  ),
  size: 150,
  minSize: 100,
});
